<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-autocomplete
            v-model="givenValue"
            :items="foundPeople"
            v-bind="[$attrs]"
            :loading="
              $apollo.queries.person.loading ||
              $apollo.queries.people.loading ||
              $apollo.queries.personDeepSearch.loading
            "
            :search-input.sync="personSearch"
            :label="label || $t('common:person.label')"
            no-filter
            :data-test="dataTest"
            item-value="id"
            append-icon="$iconSearch"
            hide-no-data
            :clearable="clearable"
            outlined
            v-on="$listeners"
            @change="[$emit('change')]"
            @input="hide = false"
            @focus="hide = true"
            @blur="hide = false"
          >
            <template #selection="{ item }">
              <slot name="selection" v-bind="{ item }">
                <span v-show="!hide">
                  <AppShowPersonWithDetails
                    v-if="showDetails"
                    :person="item"
                    :details-to-show="personDetailsToShow"
                    no-link
                  />
                  <AppShowPersonName v-else :person="item" no-link />
                </span>
              </slot>
            </template>
            <template #item="{ item }">
              <slot name="item" v-bind="{ item }">
                <AppShowPersonWithDetails
                  v-if="showDetails"
                  :person="item"
                  :details-to-show="personDetailsToShow"
                  no-link
                />
                <AppShowPersonName v-else :person="item" no-link />
              </slot>
            </template>
          </v-autocomplete>
        </div>
      </template>
      <span>{{
        $t(
          "common:filters.search.tooltip.FilterWithTyping",
          "Please start typing a name (min 3 characters)",
          "Tooltip for filters, when user should start typing the name"
        )
      }}</span>
    </v-tooltip>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
import AppShowPersonWithDetails from "@AppShows/person/AppShowPersonWithDetails.vue";

export default {
  name: "AppSelectPerson",
  components: { AppShowPersonName, AppShowPersonWithDetails },
  props: {
    value: {
      type: [String, Object],
      default: null
    },
    possibleValues: {
      type: Array,
      default: () => []
    },
    useDeepSearch: {
      type: Boolean,
      default: false
    },
    showIdentifier: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    dataTest: {
      type: String,
      default: "personSelect"
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    personDetailsToShow: {
      type: Array,
      default: () => []
    },
    personFragment: {
      type: Object,
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      person: null,
      people: [],
      personDeepSearch: [],
      personSearch: "",
      hide: false
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    foundPeople() {
      const person =
        this.givenValue && this.givenValue.constructor === Object
          ? this.givenValue
          : this.person;
      if (person) {
        return [person, ...this.people, ...this.personDeepSearch];
      }
      return [...this.people, ...this.personDeepSearch];
    }
  },
  apollo: {
    people: {
      query() {
        return gql`
        query appSelectPersonSearch($keyword: String, $personIds: [ID]) {
          people (keyword: $keyword, personIds: $personIds) {
            ${this.personFragment ? this.personFragment : ""}
            ${
              this.showDetails
                ? AppShowPersonWithDetails.fragments.person
                : AppShowPersonName.fragments.person
            }
          }
        }
      `;
      },
      debounce: 550,
      skip() {
        if (this.useDeepSearch) return true;
        return !this.personSearch || this.personSearch.length < 3;
      },
      variables() {
        return {
          keyword: this.possibleValues.length == 0 ? this.personSearch : null,
          personIds: this.possibleValues
        };
      }
    },
    person: {
      query() {
        return gql`
          query appSelectPersonFind($id: ID!) {
            person(id: $id) {
              ${this.personFragment ? this.personFragment : ""}
              ${
                this.showDetails
                  ? AppShowPersonWithDetails.fragments.person
                  : AppShowPersonName.fragments.person
              }
            }
          }
        `;
      },
      skip() {
        if (!this.value) return true;
        return this.value.constructor != String;
      },
      variables() {
        return {
          id: this.value
        };
      },
      fetchPolicy: "cache-first"
    },
    personDeepSearch: {
      query() {
        return gql`
        query personDeepSearch ($keyword: String) {
          personDeepSearch (keyword: $keyword) {
            ${this.personFragment ? this.personFragment : ""}
             ${
               this.showDetails
                 ? AppShowPersonWithDetails.fragments.person
                 : AppShowPersonName.fragments.person
             }
          }
        }
      `;
      },
      debounce: 550,
      skip() {
        if (!this.useDeepSearch) return true;
        return !this.personSearch || this.personSearch.length < 3;
      },
      variables() {
        return {
          keyword: this.personSearch
        };
      }
    }
  },
  fragments: {
    personDetailsFields: gql`
      fragment _ on Person {
        id
        ${AppShowPersonWithDetails.fragments.person}
      }
    `
  },
  methods: {
    // Shop.vue calls this method to clear the search results
    flushPeople() {
      this.people = [];
      this.person = null;
      this.personSearch = "";
    }
  }
};
</script>
